var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('center',[_c('h1',[_vm._v("404 Not Found")]),_c('p',[_vm._v("The page you are looking for has not been found.")]),_c('p',[_vm._v("Note that the website is still under development, so check back in a couple of days")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }